import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialTransportReportFilterData,
  InitialTransportReportFilterDataVariables
} from "./types/InitialTransportReportFilterData";
import {
  transportReport,
  transportReportVariables
} from "./types/transportReport";
import {
  transportReportDownload,
  transportReportDownloadVariables
} from "./types/transportReportDownload";

export const transportReportListQuery = gql`
  ${pageInfoFragment}
  query transportReport(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: TransportReportFilterInput!
  ) {
    transportReport(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          order_code
          store_order_status
          delivery_type
          shipping_method_name
          courier
          payment_method_type
          price_paid
        }
      }
    }
  }
`;

export const useTransportReportListQuery = makeBossQuery<
  transportReport,
  transportReportVariables
>(transportReportListQuery);

export const transportReportDownloadQuery = gql`
  ${pageInfoFragment}
  query transportReportDownload(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: TransportReportFilterInput!
  ) {
    transportReport(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          mall_name
          order_code
          brand_name
          store_order_status
          vertical
          delivery_type
          voucher_code
          store_order_code
          payment_method_type
          shipping_method_name
          price_paid
          customer_name
          contact_no
          email
          street_address_1
          delivery_distance_in_km
          created
          shipping_schedule
          booked_at
          shipped_at
          shipping_company
          completed_at
          completed_by
          canceled_at
          cancelled_by
          cancel_reason
          rider_name
          rider_contact_no
          latitude
          longitude
          trip_distance
          courier
          order_collect_date
          rider_contact_no
          rider_arrive_time
          late_delivery_reason
          late_dispatch_reason
          total_time
          dwell_time
          actual_lat
          actual_long
          on_time
        }
      }
    }
  }
`;
export const useTransportReportDownloadQuery = makeBossQuery<
  transportReportDownload,
  transportReportDownloadVariables
>(transportReportDownloadQuery);

export const initialTransportReportFilterDataQuery = gql`
  query InitialTransportReportFilterData($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }

    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialTransportReportFilterDataQuery = makeQuery<
  InitialTransportReportFilterData,
  InitialTransportReportFilterDataVariables
>(initialTransportReportFilterDataQuery);
